var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    isolate: "isolate",
    opacity: 0.01,
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.93,18.87v28H22.32A4,4,0,0,0,19.49,48L16,51.5V18.87Zm4-8H12a4,4,0,0,0-4,4V61.14A4,4,0,0,0,14.83,64l8-8a4,4,0,0,1,2.82-1.18H63.91a4,4,0,0,0,4-4V14.88A4,4,0,0,0,63.91,10.88Zm20,16h-8V58.8a4,4,0,0,1-4,4H24v8a4,4,0,0,0,4,4H70.25A4,4,0,0,1,73.08,76l8,8a4,4,0,0,0,6.83-2.83V30.85A4,4,0,0,0,83.89,26.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1074485b9e0b3b6294a89b2258effce7.svg";
export { ForwardRef as ReactComponent };